import React from "react";

const FOUNDING_TEAM = [
  {
    id: "can",
    name: "Can",
    roleLines: ["Co-Founder &", "Chief Executive Officer"],
    image: "/images/Founder1.png",
  },
  {
    id: "vivek",
    name: "Vivek Thakur",
    roleLines: ["Co-Founder &", "Chief Technical Officer"],
    image: "/images/Founder3.jpeg",
  },
  {
    id: "jonathan",
    name: "Jonathan Henry Katz",
    roleLines: ["Co-Founder &", "Chief Operations Officer"],
    image: "/images/Founder2.jpeg",
  },
];

const FOUNDER_NOTE = {
  quote:
    "Enterprises don't lack information — they lack clarity, compliance, and connected intelligence.",
  paragraphs: [
    "We started Highwatch because we kept seeing the same problem inside regulated enterprises: not a shortage of data, but a shortage of trust in what that data was telling them. Systems that didn't talk to each other. Decisions made without the full picture. Compliance treated as paperwork instead of architecture.",
    "Highwatch was built to change that — one explainable, auditable layer underneath every team's daily work, starting with Insurance and built to extend to every regulated industry we serve next.",
    "This is still early. We're building it deliberately, with the people who'll actually use it every day.",
  ],
  name: "Can",
  title: "Co-Founder & CEO, Highwatch AI",
};

export default function FounderSection() {
  return (
    <section className="about-founder" aria-label="Founding team">
      <div className="about-founder__wrap">
        <h2 className="about-founder__heading">Founding team</h2>

        <div className="about-founder__team">
          {FOUNDING_TEAM.map((member) => (
            <article key={member.id} className="about-founder__member">
              <div className="about-founder__photo-wrap">
                <img
                  src={member.image}
                  alt={member.name}
                  className="about-founder__photo"
                  loading="lazy"
                />
              </div>
              <strong className="about-founder__name">{member.name}</strong>
              <span className="about-founder__role">
                {member.roleLines.map((line) => (
                  <span key={line} className="about-founder__role-line">
                    {line}
                  </span>
                ))}
              </span>
            </article>
          ))}
        </div>

        <div className="about-founder__note">
          <h3 className="about-founder__quote">&ldquo;{FOUNDER_NOTE.quote}&rdquo;</h3>
          <div className="about-founder__body">
            {FOUNDER_NOTE.paragraphs.map((paragraph) => (
              <p key={paragraph.slice(0, 32)}>{paragraph}</p>
            ))}
          </div>
          <div className="about-founder__sign">
            <strong>{FOUNDER_NOTE.name}</strong>
            <span>{FOUNDER_NOTE.title}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

